import dynamic from 'next/dynamic';

// const CollectionAccordion = dynamic(() => import('./components/CollectionAccordion'));
// const Quote = dynamic(() => import('./components/Quote'));
const Accordion = dynamic(() => import('./components/Accordion'));
const Article = dynamic(() => import('./components/Article/Article'));
const ArticleEmbeded = dynamic(() => import('./components/Article/ArticleEmbeded'));
const AutocompleteBox = dynamic(() => import('./components/AutocompleteBox'));
const BackToTop = dynamic(() => import('./components/BackToTop'));
const Card = dynamic(() => import('./components/Card'));
const Chat = dynamic(() => import('./components/Chat'));
const CodeSnippet = dynamic(() => import('./components/CodeSnippet'));
const Collection = dynamic(() => import('./components/Collection'));
const CollectionAccordion = dynamic(() => import('./components/CollectionAccordion'));
const CollectionCarousel = dynamic(() => import('./components/CollectionCarousel'));
const CollectionFiltered = dynamic(() => import('./components/CollectionFiltered'));
const CollectionSearchFilters = dynamic(() => import('./components/CollectionSearchFilters'));
const CollectionSearchResults = dynamic(() => import('./components/CollectionSearchResults'));
const Document = dynamic(() => import('./components/Document'));
const Footer = dynamic(() => import('./components/Footer'));
const Header = dynamic(() => import('./components/Header'));
const Hero = dynamic(() => import('./components/Hero'));
const Link = dynamic(() => import('./components/Link'));
const Media = dynamic(() => import('./components/Media'));
const NavigationBar = dynamic(() => import('./components/NavigationBar'));
const NavigationItem = dynamic(() => import('./components/NavigationItem'));
const Page = dynamic(() => import('./components/Page'));
const PageTopic = dynamic(() => import('./components/PageTopic'));
const RichText = dynamic(() => import('./components/RichText'));
const SearchBox = dynamic(() => import('./components/SearchBox'));
const Section = dynamic(() => import('./components/Section'));
const Table = dynamic(() => import('./components/Table'));
const Text = dynamic(() => import('./components/Text'));
const TopicNav = dynamic(() => import('./components/TopicNav'));
const TopicNavHorizontal = dynamic(() => import('./components/TopicNavHorizontal'));

const contentMapping: {
  [key: string]: any;
} = {
  'Article:embeded': ArticleEmbeded,
  'CategoryArticle': PageTopic,
  'Collection:accordion': CollectionAccordion,
  'Collection:carousel-large': CollectionCarousel,
  'Collection:carousel-small': CollectionCarousel,
  'Collection:carousel': CollectionCarousel,
  'Collection:filtered': CollectionFiltered,
  'Collection:navigation-bar': NavigationBar,
  'Collection:Search Filters': CollectionSearchFilters,
  'Collection:Search Results': CollectionSearchResults,
  'CollectionExpandable': Accordion,
  'ModuleIntegration:chat': Chat,
  'ModuleIntegration:autocomplete-search-box': AutocompleteBox,
  'ModuleIntegration:search-box': SearchBox,
  Article,
  BackToTop,
  Card,
  CodeSnippet,
  Collection,
  Document,
  Footer,
  Header,
  Hero,
  Link,
  Media,
  NavigationItem,
  Page,
  PageTopic,
  RichText,
  Section,
  Table,
  Text,
  TopicNav,
  TopicNavHorizontal
};

export default contentMapping;
